import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environment/environment";

@Injectable({
    providedIn: 'root',
})
export class TwilioService {
    public url = 'communications/twilio';

    constructor(
        private _http: HttpClient
    ){
    }
    
    public getContentSid(contentSid:string): Observable<object> {
        let url = environment.api_gw + this.url + '/ContentSID/' + contentSid;
        return this._http.get<object>(url);
    }

}
